"use client";

import { useEffect } from "react";
import { captureAffiliateParams } from "./affiliate-tracker";

const AffiliateTracker = () => {
  useEffect(() => {
    captureAffiliateParams();
  }, []);

  return null;
};

export default AffiliateTracker;
